import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
let { meet_id = '',  roleType = 0, status = 2, timer_type = 0} = JSON.parse(localStorage.getItem('meetingInfo')) || {}
const state = {
  //要设置的全局访问的state对象
  complete: 0,
  showApp: false,
  showLoading: false,
  showLoadingText: '正在加载数据',
  meetingInfo: {
    meet_id,
    roleType,
    status,
    timer_type
  }
  //要设置的初始属性值
};

const mutations = {
  changeComplete(state, newVal) {
    state.complete = newVal;
  },
  changeMeetingInfo(state, newVal) {
    if(newVal) { localStorage.setItem('meetingInfo', JSON.stringify({...state.meetingInfo, ...newVal})) }
    state.meetingInfo = {...state.meetingInfo, ...newVal}
  },
  changeAppShow(state, newVal) {
    state.showApp = newVal
  },
  changeLoading(state, newVal) {
    state.showLoadingText = newVal.text || '数据加载中'
    state.showLoading = newVal.status;
  }
};

const actions = {
  changeComplete(context, newVal) {
    context.commit("changeComplete", newVal);
  }
};

const getters = {
  getComplete(state) {
    return state.complete;
  }
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js